(function Module() {
	'use strict';

	mySynch.controller('FarmBreedingCodesController', [
		'$scope',
		'MySynchFactory',
		'ApiFactory',
		'ViewAuthorizationFactory',
		'pageTrackerService',
		'deviceDetector',
		'mySynchEnumerationService',
		'performanceMetricsService',
		'performanceContextService',
		'$q',
		'clientLoggerService',
		function FarmBreedingCodesController($s, MSF, api, viewAuth, pageTracker,deviceDetector,mySynchEnumSvc, perfMetricSvc, perfContextSvc, $q, log) {
			var self = this;
			$s.isMobile = deviceDetector.isMobile();
			$s.performanceContext = null;

			// dregister functions
			var deregRouteChange = null
			var deregOnHerdChange = null;
			$s.canUpdate = function canUpdate() {
				return viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission','HERD_DATA_UPDATE'));
			};

			//function routeChange(event, newUrl, oldUrl) {
			function routeChange(event, next, nextParams, current, currentParams) {
				var formIsPristine = _.get(event,'currentScope.farmBreedingCodesCtrl.breedingCodesForm.$pristine');
				if (_.isUndefined(formIsPristine) || formIsPristine) {
					return;
				}

				MSF.confirm('unsavedChanges', function confirmed() {
					onRouteChangeOff(); // this deregisters the listener
					MSF.loadPage(next.name,nextParams);
					$s.$apply();
				});

				event.preventDefault();

				return;
			}

			deregRouteChange = $s.$on('$stateChangeStart', routeChange);

			$s.aiTypes = [
				{aiTypeId: '',	code: '',			name: '--Select--'},
				{aiTypeId: 1,	code: 'TAI',		name: 'Timed Artificial Insemination (TAI)'},
				{aiTypeId: 2,	code: 'HDAI',		name: 'Heat Detect Artificial Insemination (HDAI)'},
				{aiTypeId: 3,	code: 'UNKNOWN',	name: 'Unknown Insemination Type'}
			];

			self.farm = {};
			$s.loading = false;

			self.removeItem = function removeItem(item) {
				self.breedingCodes = _.without(self.breedingCodes, item);
				$s.farmBreedingCodesCtrl.breedingCodesForm.$setDirty();
			};

			self.add = function add() {
				var currentHerd = MSF.getActiveHerd();

				if (!currentHerd) {
					return false;
				}

				self.breedingCodes.push({code: '', description: '', aiTypeId: '', herdId: currentHerd.herdId});
				$s.farmBreedingCodesCtrl.breedingCodesForm.$setDirty();
			};

			self.saveBreedingCodes = function saveBreedingCodes(isValid) {
				if (!isValid) {
					MSF.touchForm($s.farmBreedingCodesCtrl.breedingCodesForm);

					return;
				}

				var currentHerd = MSF.getActiveHerd();

				if (!currentHerd) {
					return false;
				}

				$s.saving = true;

				api.setBreedingCodesByHerdId(currentHerd.herdId, {breedingCodes: self.breedingCodes}, function breedingCodesUpdated(err) {
					$s.saving = false;

					if (err) {
						log.error(err);
						MSF.notify.danger('Error occurred trying to save breeding codes: ' + err);

						return false;
					}

					$s.farmBreedingCodesCtrl.breedingCodesForm.$setPristine();
					MSF.notify.success('Changes saved successfully');
				});
			};

			function refresh() {
				if (!viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission','HERD_DATA_READ'))) {	
					return MSF.loadPage('Login');
				}
				var pageLoadPromise = $q.defer();
				var currentHerd = MSF.getActiveHerd();

				if (!currentHerd || !currentHerd.herdId) {
					pageLoadPromise.resolve();
				}

				$s.loading = true;
				self.breedingCodes = [];
				perfMetricSvc.startTiming('Page:BreedingCodesPageData:Request');
				api.getBreedingCodesByHerdId(currentHerd.herdId, $s.performanceContext, function breedingCodesLoaded(err, data) {
					perfMetricSvc.endTiming("page",'Page:BreedingCodesPageData:Request', $s.performanceContext);
					perfMetricSvc.startTiming('Page:BreedingCodesPageData:Build');
					$s.loading = false;

					if (err) {
						log.error(MSF.notify.danger('unable to get breeding codes for herd: ' + err));
						self.breedingCodes = [];
						perfMetricSvc.endTiming("page",'Page:BreedingCodesPageData:Build', $s.performanceContext);

						pageLoadPromise.resolve();
					}

					// -----------
					var personKey	= MSF.cookies.user.PersonKey;
					var herdKey		= MSF.activeHerd.herdKey;

					if (!herdKey) {
						herdKey		= MSF.cookies.state.activeFarm.herds[0].herdKey;
					}

					if (personKey && herdKey) {
						pageTracker.trackPageView(personKey, herdKey, '(Breeding Codes Tab)');	// no need to pass a callback because this is fire and forget
					}
					// -----------

					self.breedingCodes = _.map(data, function mapData(row) {
						// modify row as needed
						row.code = (row.code || '').toUpperCase();

						return row;
					});
					perfMetricSvc.endTiming("page",'Page:BreedingCodesPageData:Build', $s.performanceContext);
					pageLoadPromise.resolve();	
				});
				return pageLoadPromise.promise;
			}

			$s.loading	= true;
			$s.saving	= false;

			deregOnHerdChange = $s.$on('herd:changed', ()=> {
				$s.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(),'herdId', null));
				perfMetricSvc.startTiming('Page:BreedingCodesOnHerdChange:Render');
				refresh().then(() => {
					perfMetricSvc.markPageReady('Page:BreedingCodesOnHerdChange:Render', $s.performanceContext);
				});	
			});

			$s.$on('$destroy', () => {
				if (deregRouteChange) {
					deregRouteChange();
				}
				if (deregOnHerdChange) {
					deregOnHerdChange();
				}
				$s.performanceContext = null;
			});

			MSF.ready(()=> {
				$s.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(),'herdId', null));
				perfMetricSvc.startTiming('Page:BreedingCodes:Render');
				refresh().then(() => {
					perfMetricSvc.markPageReady('Page:BreedingCodes:Render', $s.performanceContext);
				});
			});
		}
	]);
})();
